import { Button, Col, Input, Row, Select } from 'antd';
import { useCallback, useEffect } from 'react';
import { BsPerson } from 'react-icons/bs';
import { MdOutlineAccountBalanceWallet } from 'react-icons/md';
import { normalizeCpfCnpj } from 'helpers/normalizers';
import { CustomDrawer } from 'components/CustomDrawer';
import { LuSearch } from 'react-icons/lu';
import { cleanDocument } from 'helpers/documentUtils';
import { cpfCnpjRule } from 'helpers/rules';
import { useCurrentProfile } from 'modules/core/context/ProfileContext';
import { FiltersForm, FiltersFormItem } from './PixFilters.styles';
import { EPix, TPixFilters, pixStatusDescription } from '../types';

interface IPixFiltersComponentProps {
	isOpen: boolean;
	filters?: TPixFilters;
	onClose: () => void;
	onApply: (filters: TPixFilters) => void;
}
const PixFiltersComponent = ({
	isOpen,
	filters,
	onApply,
	onClose,
}: IPixFiltersComponentProps) => {
	const { type } = useCurrentProfile();
	const [form] = FiltersForm.useForm();

	const onFinish = useCallback(
		(values: TPixFilters) => {
			onApply({
				...values,
				taxpayer_id:
					values.taxpayer_id && values.taxpayer_id.length > 0
						? cleanDocument(values.taxpayer_id)
						: undefined,
				date: values.start_date ? values.start_date : undefined,
				status: values.status ? values.status : undefined,
			} as TPixFilters);
		},
		[onApply],
	);

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				taxpayer_id:
					filters?.taxpayer_id &&
					normalizeCpfCnpj(filters?.taxpayer_id),
				status: filters?.status,
				date: filters?.start_date,
			});
		}
	}, [isOpen, form, filters]);

	return (
		<CustomDrawer
			onClose={onClose}
			open={isOpen}
			title="Busca avançada"
			footer={
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<Button
							style={{
								display: 'flex',
								alignItems: 'center',
								width: '100%',
								justifyContent: 'center',
								position: 'relative',
							}}
							size="large"
							type="primary"
							onClick={form.submit}
						>
							Aplicar filtros
							<LuSearch
								size={21}
								style={{ position: 'absolute', right: '15px' }}
							/>
						</Button>
					</Col>
				</Row>
			}
		>
			<FiltersForm
				layout="vertical"
				form={form}
				onFinish={onFinish}
				initialValues={
					{
						taxpayer_id:
							filters?.taxpayer_id &&
							normalizeCpfCnpj(filters?.taxpayer_id),
						status: filters?.status,
						date: filters?.start_date,
					} as TPixFilters
				}
			>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<FiltersFormItem
							name="taxpayer_id"
							label="CPF / CNPJ do devedor"
							normalize={value => normalizeCpfCnpj(value)}
							rules={[cpfCnpjRule]}
						>
							<Input
								placeholder="Digite aqui"
								prefix={<BsPerson />}
							/>
						</FiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<FiltersFormItem label="Conta" name="account">
							<Input
								placeholder="Data de vencimento"
								prefix={<MdOutlineAccountBalanceWallet />}
							/>
						</FiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<FiltersFormItem name="status" label="Status">
							<Select
								style={{ minWidth: '10rem' }}
								placeholder="Selecionar"
								allowClear={true}
								options={Object.keys(pixStatusDescription).map(
									key => ({
										label: pixStatusDescription[
											key as EPix
										],
										value: key,
									}),
								)}
							/>
						</FiltersFormItem>
					</Col>
				</Row>
			</FiltersForm>
		</CustomDrawer>
	);
};

export default PixFiltersComponent;
